import { Drawer, List, ListItem, SvgIcon, Toolbar, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { get, map } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useRouter } from 'src/hooks/useRouter';
import { MENU } from '../../constants/menu';
import { useAuth } from '../../hooks';
import { Icons } from '../icons';
import { Logo } from '../logo';
import useStyles from './styles';

interface SidebarProps {
  width: number;
  mobileOpen: boolean;
  setMobileOpen: (state: boolean) => void;
}

export const Sidebar: ComponentType<SidebarProps> = ({ width, mobileOpen, setMobileOpen }) => {
  const classes = useStyles();
  const { user } = useAuth();
  const { asPath } = useRouter();
  const { t } = useTranslation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const nav = get(MENU, [user?.data?.role], MENU.DEFAULT);

  const drawer = (
    <>
      <Toolbar className={classes.toolbar}>
        <Logo sx={{ fontSize: 40 }} />
      </Toolbar>
      <List className={classes.nav} sx={{ p: 0 }} component="div">
        {map(nav, ({ icon, path, key, label }, index) => (
          <ListItem
            button
            key={index}
            selected={asPath === path}
            classes={{
              root: classes.navItem,
              selected: classes.navItemSelected,
            }}
            component={NavLink}
            to={path}
          >
            <SvgIcon component={Icons[icon]} viewBox="0 0 24 24" className={classes.navItemIcon} />
            <Typography
              variant={asPath === path ? 'subtitle2' : 'body2'}
              className={classes.navItemLabel}
              component="span"
            >
              {t(key, label)}
            </Typography>
          </ListItem>
        ))}
      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: width }, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
      className={classes.root}
    >
      <Drawer
        // container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: width },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: width },
        }}
        open
        classes={{
          root: classes.drawer,
          paper: classes.drawerPaper,
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};
